import AddOnPlanCardRenderer from './AddOnPlanCardRenderer';

export default AddOnPlanCardRenderer;
